"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var questions_1 = require("@caddigital/sok-reducers/lib/reducers/bid/questions");
var questionsActions = require("@caddigital/sok-reducers/lib/actions/bid/questions");
var bidQuestionAnswerFile_1 = require("actions/bidQuestionAnswerFile");
var epics_1 = require("utils/upload/epics");
/** Handler for single file upload (called by FILEUPLOAD_REQUEST epic) */
var epics = (0, epics_1.createEpics)('@sok/web/bid/question/answerFile', function (state) { return state.bidQuestionAnswerFile; });
function saveMetas(session, questionFolder, fetchOptions) {
    // Get metas
    // Save metas
    return (0, rxjs_1.of)(session).pipe((0, operators_1.mergeMap)(function (session) {
        return fetchOptions
            .ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: fetchOptions.getToken()
            },
            method: 'POST',
            body: {
                hierarchyType: 'SESSION',
                sessionUuid: session,
                metas: {}
            },
            url: "".concat(fetchOptions.baseUrl, "api/files/metadata/save")
        })
            .pipe((0, operators_1.flatMap)(function () {
            return (0, rxjs_1.of)(bidQuestionAnswerFile_1.default.fileuploadDone(), questionsActions.saveMetasSuccess(), questionsActions.ListActions.fetchRequest(questionFolder, questions_1.sortByOptions, questions_1.searchOptions));
        }));
    }));
}
function fileUploadDone(action$, store, fetchOptions) {
    var successAction = '@sok/web/bid/question/answerFile/FILEUPLOAD_FILE_SUCCESS';
    var failureAction = '@sok/web/bid/question/answerFile/FILEUPLOAD_FILE_FAILURE';
    return action$.pipe((0, operators_1.filter)(function (action) { return action.type === successAction || action.type === failureAction; }), (0, operators_1.mergeMap)(function () {
        var state = store.value;
        var subState = state.bidQuestionAnswerFile;
        var filesInUploading = subState.uploadedFiles;
        var itemsSoFar = Object.values(filesInUploading).filter(function (i) { return i.status === 'UPLOADED'; });
        var allDone = itemsSoFar.length === subState.currentUploadStatus.totalFiles;
        // Upload modal
        if (allDone) {
            // If upload modal is open then we can set upload progress done and redirect user to metaeditor
            var session = subState.currentUploadStatus.session;
            if (subState.modalState.isOpen &&
                session &&
                subState.currentUploadStatus.folderId) {
                return (0, rxjs_1.merge)((0, rxjs_1.of)(questionsActions.saveMetasRequest()), saveMetas(session, subState.currentUploadStatus.folderId, fetchOptions));
            }
        }
        return (0, rxjs_1.empty)();
    }));
}
exports.default = (0, redux_observable_1.combineEpics)(epics.initFileUpload, epics.handleFileUpload, epics.cancelUploadSession, fileUploadDone);
